import { render, staticRenderFns } from "./CustomTemplate.vue?vue&type=template&id=3f7ba672&scoped=true&"
import script from "./CustomTemplate.vue?vue&type=script&lang=js&"
export * from "./CustomTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CustomTemplate.vue?vue&type=style&index=0&id=3f7ba672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7ba672",
  null
  
)

export default component.exports